import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from './../../../../environments/environment';
import {TermsContentComponent} from "../terms-content/terms-content.component";
import {ModalService} from "../../services/modal.service";
import {AuthService} from "../../services/auth.service";
import {SubscriptionService} from "../../services/subscription.service";
import { properties } from 'src/environments/properties';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
    faqUrlConfig;
    faqURL: any;
    @Input() userSubscriptionDetails: any;
    @Input() userInfo: any;
    @Input() currentEnvironment;
    properties = properties;
    
    enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
    programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

    constructor(private router: Router,
                public subscriptionService: SubscriptionService,
                private modalService: ModalService,
                public authService: AuthService,
                private activeRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        if (environment[this.currentEnvironment]) {
            this.faqUrlConfig = environment[this.currentEnvironment].freshpassFAQ;
        }
        this.getFAQUrl();
    }

    getFAQUrl() {
        const domainName = this.subscriptionService.getApplicationDomainURL();
        this.faqURL = domainName + this.faqUrlConfig;
    }

    redirectToFAQ() {
        this.router.navigate([this.programDisplayData?.urlPath?.FAQ_PATH]);
    }

    openTerms(userSubscriptionDetails, userInfo) {
        this.activeRoute.data.subscribe(data => {
                let isSessionValid = this.authService.isTokenValidForSession(data.tokenObject)
                if (isSessionValid) {
                    const sessionData = {...(data.tokenObject), authToken: data.tokenObject['SWY_SHOP_TOKEN']};
                    if (sessionData) {
                        this.userInfo = sessionData;
                        this.subscriptionService.getTerms(this.userInfo, this.currentEnvironment).subscribe((data) => {
                            if (data && data.content) {
                                this.modalService.openModalWithComponent(TermsContentComponent, {
                                    initialState: {
                                        userSubscriptionDetails: userSubscriptionDetails,
                                        userInfo: userInfo,
                                        content: data.content
                                    },
                                    class: 'slot-picker-modal',
                                    backdrop: 'static',
                                    ariaDescribedby: 'slot-msg',
                                    ariaLabelledBy: "dialoghead-slot-details",
                                });
                            }
                        });
                    }
                } else {
                    this.authService.redirectToSSO(data.tokenObject)
                }
            },
            (err => {
                this.authService.redirectToSSO({});
            }));
    }


}
